export class QuarantinedDocumentsUpdateRequest {
    documentNumber!: string;
    version!: number;
    phase!: number;

    public constructor(documentNumber: string, version: number, phase: number) {
        this.documentNumber = documentNumber;
        this.version = version;
        this.phase = phase;
    }
}
